import type { NodeDefinition } from "../domain/types/index.js";

function node(id: string, kind: NodeDefinition["kind"], x: number, y: number, next: readonly string[]): NodeDefinition {
  return { id, kind, x, y, next, ...(kind === "case" ? { caseId: id === "boss" ? "inheritance-boss" : id } : {}) };
}

// 第17期。手札妨害・滞留・疲労の3地域。現在のデッキが耐えられる攻撃と、取るべき報酬規模を選ぶ。
export const MAP_NODES_INHERITANCE: Record<string, NodeDefinition> = Object.fromEntries([
  node("start", "start", 3, 0, ["p17-brief"]),
  node("p17-brief", "case", 3, 1, ["p17-inventory"]),
  node("p17-inventory", "case", 3, 2, ["p17-mentor", "p17-catalog", "p17-alliance"]),

  // 左: 手札妨害。大型プロジェクトを踏んで高い報酬を取るか、休んで安定した小型PJを取るか。
  node("p17-mentor", "case", 1, 3, ["p17-handbook", "p17-rest-left"]),
  node("p17-handbook", "case", 0, 4, ["p17-shadow"]),
  node("p17-rest-left", "rest", 2, 4, ["p17-shadow"]),
  node("p17-shadow", "case", 1, 5, ["p17-event-left", "p17-coach"]),
  node("p17-event-left", "event", 0, 6, ["p17-coach"]),
  node("p17-coach", "case", 1, 7, ["p17-delegate", "p17-transfer"]),
  node("p17-delegate", "case", 0, 8, ["p17-steward"]),
  node("p17-transfer", "case", 2, 8, ["p17-record"]),
  node("p17-steward", "case", 0, 9, ["p17-review-left"]),

  // 中央: 滞留。大型の記録統合で報酬を伸ばすか、小型PJで手札を保ってから最終合意へ進む。
  node("p17-catalog", "case", 3, 3, ["p17-archive"]),
  node("p17-archive", "case", 3, 4, ["p17-event-center"]),
  node("p17-event-center", "event", 4, 5, ["p17-interface"]),
  // 高負荷の記録統合を選べば基盤を取れる。安定した手順試行を選ぶ場合はカード報酬を優先する。
  node("p17-interface", "case", 3, 6, ["p17-relic-record", "p17-guideline"]),
  node("p17-guideline", "case", 4, 7, ["p17-alignment"]),
  node("p17-relic-record", "relic", 3, 8, ["p17-record"]),
  node("p17-record", "case", 3, 9, ["p17-alignment"]),
  node("p17-alignment", "case", 4, 10, ["p17-review-center"]),

  // 右: 疲労・不要人員。大型の連携拡張か、小型の共同ルールで疲労の残り方を見ながら進む。
  node("p17-alliance", "case", 5, 3, ["p17-negotiation", "p17-rest-right"]),
  node("p17-negotiation", "case", 5, 4, ["p17-pilot"]),
  node("p17-rest-right", "rest", 6, 4, ["p17-pilot"]),
  node("p17-pilot", "case", 5, 5, ["p17-sponsor"]),
  node("p17-sponsor", "case", 5, 6, ["p17-scale", "p17-govern"]),
  // 連携範囲を拡張する選択には、共同で運用するための基盤獲得を添える。
  node("p17-scale", "case", 5, 7, ["p17-relic-scale"]),
  node("p17-govern", "case", 6, 7, ["p17-committee"]),
  node("p17-relic-scale", "relic", 5, 8, ["p17-committee"]),
  node("p17-committee", "case", 5, 9, ["p17-review-right"]),

  // 最終レビューでは、残った弱点に合わせて滞留型か疲労型の最終プロジェクトを選ぶ。
  node("p17-review-left", "case", 1, 11, ["p17-final-left"]),
  node("p17-review-center", "case", 3, 11, ["p17-final-left", "p17-final-right"]),
  node("p17-review-right", "case", 5, 11, ["p17-final-right-alt"]),
  node("p17-final-left", "case", 2, 12, ["p17-continuity-left"]),
  node("p17-final-right", "case", 4, 12, ["p17-continuity-right"]),
  node("p17-final-right-alt", "case", 5, 12, ["p17-continuity-right"]),
  node("p17-continuity-left", "case", 2, 13, ["boss"]),
  node("p17-continuity-right", "case", 4, 13, ["boss"]),
  node("boss", "case", 3, 15, []),
].map(n => [n.id, n]));
